(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  onReady(() => {
    const header = document.querySelector('[data-yelo-header]');
    const menuToggle = header?.querySelector('[data-yelo-menu-toggle]');
    const nav = header?.querySelector('[data-yelo-nav]');
    const scrollContainer = document.querySelector('.page-wrapper');

    const updateHeader = () => {
      const scrollTop = scrollContainer?.scrollTop || window.scrollY;
      header?.classList.toggle('is-scrolled', scrollTop > 32);
    };

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
    scrollContainer?.addEventListener('scroll', updateHeader, { passive: true });

    menuToggle?.addEventListener('click', () => {
      const open = header.classList.toggle('is-menu-open');
      menuToggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (scrollContainer) scrollContainer.style.overflowY = open ? 'hidden' : '';
    });

    nav?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        header.classList.remove('is-menu-open');
        menuToggle?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        if (scrollContainer) scrollContainer.style.overflowY = '';
      });
    });

    const filters = [...document.querySelectorAll('[data-gallery-filter]')];
    const galleryItems = [...document.querySelectorAll('[data-gallery-item]')];
    const galleryEmpty = document.querySelector('[data-gallery-empty]');
    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        const category = filter.dataset.galleryFilter;
        filters.forEach((item) => {
          const active = item === filter;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        let visibleCount = 0;
        galleryItems.forEach((item) => {
          const visible = category === 'all' || item.dataset.galleryCategory === category;
          item.classList.toggle('is-hidden', !visible);
          if (visible) visibleCount += 1;
        });
        if (galleryEmpty) galleryEmpty.hidden = visibleCount > 0;
      });
    });

    const lightbox = document.querySelector('[data-yelo-lightbox]');
    const lightboxImage = lightbox?.querySelector('.yelo-lightbox__image');
    const lightboxClose = lightbox?.querySelector('[data-yelo-lightbox-close]');
    let lightboxTrigger = null;

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (scrollContainer) scrollContainer.style.overflowY = '';
      lightboxTrigger?.focus();
    };

    galleryItems.forEach((item) => {
      item.addEventListener('click', () => {
        const image = item.querySelector('img');
        if (!lightbox || !lightboxImage || !image) return;
        lightboxTrigger = item;
        lightboxImage.src = image.currentSrc || image.src;
        lightboxImage.alt = image.alt;
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (scrollContainer) scrollContainer.style.overflowY = 'hidden';
        lightboxClose?.focus();
      });
    });

    lightboxClose?.addEventListener('click', closeLightbox);
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeLightbox();
        if (header?.classList.contains('is-menu-open')) {
          header.classList.remove('is-menu-open');
          menuToggle?.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
          if (scrollContainer) scrollContainer.style.overflowY = '';
        }
      }
    });

    const contactForm = document.querySelector('#YeloContactForm');
    contactForm?.addEventListener('submit', (event) => {
      const requiredFields = [...contactForm.querySelectorAll('[required]')];
      const firstInvalid = requiredFields.find((field) => !field.checkValidity());
      if (firstInvalid) {
        event.preventDefault();
        firstInvalid.focus();
        firstInvalid.reportValidity();
      }
    });
  });
})();
